import { definePreset } from "@primeuix/themes";
import Aura from '@primeuix/themes/aura';


export default definePreset(Aura, {
  semantic: {
    primary: {
      50: '#e7edff',
      100: '#c3d3fe',
      200: '#9db7fd',
      300: '#789afd',
      400: '#5d86fc',
      500: '#155DFC',
      600: '#1353e3',
      700: '#1046c0',
      800: '#0d399c',
      900: '#0a2b79',
      950: '#06194a',
    }
  },
  components: {
    button: {
      colorScheme: {
        light: {
          root: {
            secondary: {
              // background: 'white',
              // hoverBackground: 'var(--color-blue-light)',
              // activeBackground: 'var(--color-blue)',
            },
            success: {
              // color: 'var(--color-font-primary)',
              // borderColor: 'none',
              // background: 'var(--color-blue-accent)',
              // hoverBackground: 'var(--color-blue-accent-dark)',
              // hoverBorderColor: 'none',
              // hoverColor: 'var(--color-font-primary)',
              // activeBackground: 'var(--color-blue-accent-darker)',
              // activeBorderColor: 'none',
            },
            // borderRadius: '15px',
          }
        }
      },
    },
    inputtext: {
      colorScheme: {
        light: {
          root: {
            // borderRadius: '15px',
            // placeholderColor: 'var(--color-green)',
          }
        }
      }
    },
    select: {
      colorScheme: {
        light: {
          root: {
            // borderRadius: '15px',
            // placeholderColor: 'var(--color-green)',
          }
        }
      }
    }
  }
});
